import Enums from "../../../enums/enums";
import i18n from "../../../locales/i18n";
import * as api from "../../../service/ApiSevice";
import store from "../../baseController";
export const actions = {
  DoSendVideoFeedback({ commit }, _input) {
    return new Promise((resolve) => {
      let dateTimeNow = new Date();
      const merchant = store.getters.GetMerchant;
      const user = store.getters.getUserModel;
      const position = {
        [Enums.Position.BusinessOwner]: i18n.t("business_owner"),
        [Enums.Position.Bookkeeper]: i18n.t("bookkeeper"),
        [Enums.Position.Admin]: i18n.t("Admin"),
        [Enums.Position.Accountant]: i18n.t("accountant"),
        [Enums.Position.Employee]: i18n.t("Employee"),
        [Enums.Position.AccountingFirm]: i18n.t("Accounting_Firm"),
        [Enums.Position.Student]: i18n.t("Student"),
        [Enums.Position.Other]: i18n.t("Other"),
      };
      const input = {
        userId: user.userId,
        userName: user.displayName,
        userPosition: position[user.positionId],
        merchantId: merchant.merchantId,
        merchantName: merchant.merchantName,
        userTelephone: user.phone,
        ..._input,
        createdDate: dateTimeNow,
      };

      api.UserService.DoSendVideoFeedback(input).then((res) => {
        if (res.responseCode.IsSuccess()) {
          const newUserFeedbackVideo = [...store.getters.GetUserFeedbackVideo, res.feedbackVideo];
          commit("MutationSetUserFeedbackVideo", newUserFeedbackVideo);
        }
        resolve();
      });
    });
  },
  DoGetVideoFeedback({ commit }) {
    const merchant = store.getters.GetMerchant;
    const user = store.getters.getUserModel;
    const input = {
      userId: user.userId,
      merchantId: merchant.merchantId,
    };
    commit("MutationSetUserFeedbackVideoLoadingStatus", Enums.LoadingStatusType.Loading);
    api.UserService.DoGetVideoFeedback(input).then((res) => {
      if (res.responseCode.IsSuccess()) {
        commit("MutationSetUserFeedbackVideo", res.userFeedbackVideo);
        commit("MutationSetUserFeedbackVideoLoadingStatus", Enums.LoadingStatusType.Success);
      } else {
        commit("MutationSetUserFeedbackVideoLoadingStatus", Enums.LoadingStatusType.Failed);
      }
    });
  },
};
